// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3O2RE","title":"Info_title__1qWy_","selects":"Info_selects__ZTmtr","requiredAsterisk":"Info_requiredAsterisk__FMrVG"};